import React, { useCallback, useState } from 'react'
import {
  DropdownMenu,
  DropdownItem,
  DropdownHeader,
  DropdownDivider,
  Dropdown,
  Input,
} from 'semantic-ui-react'

import { useGlobalContext } from '../../contexts/GlobalContext'
import { Container } from './style'

function convertToFullPathList(tabs, parentPath) {
  const result = []
  for (const tab of tabs) {
    const currentPath = parentPath ? `${parentPath} ⇒ ${tab.nome}` : tab.nome
    if (tab.tabulations?.length === 0) {
      result.push({
        id: tab.id,
        nome: currentPath,
        ativo: tab.ativo,
        texto_template: tab.texto_template,
        use_template: tab.use_template,
      })
    }

    if (tab.tabulations?.length) {
      result.push(...convertToFullPathList(tab.tabulations, currentPath))
    }
  }

  return result.sort((a, b) => {
    if (a.nome < b.nome) return -1
    if (a.nome > b.nome) return 1
    return 0
  })
}

export default function TabulacaoV2({ id_ticket, id_tabulacao }) {
  const { globalState, globalDispatch } = useGlobalContext()
  const { tabulacoes, tickets } = globalState
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  function findItemNameById(id, estrutura) {
    for (let i = 0; i < estrutura.length; i++) {
      if (estrutura[i].id === id) {
        return estrutura[i].nome
      }

      if (estrutura[i].tabulations.length > 0) {
        const result = findItemNameById(id, estrutura[i].tabulations)
        if (result) return result
      }
    }
  }

  const setTabulacaoLocal = useCallback(
    (id) => {
      const ticketsAlterados = tickets.map((item) => {
        if (item.id === id_ticket) {
          const tabulacao = convertToFullPathList(tabulacoes, '').find(
            (tab) => tab.id === id,
          )

          if (tabulacao.use_template) {
            item.comentario = tabulacao.texto_template
          }
          return { ...item, fk_id_tabulacao: id }
        }
        return item
      })

      globalDispatch({
        type: 'SET_DATA',
        payload: {
          tickets: ticketsAlterados,
        },
      })
    },
    [globalDispatch, id_ticket, tickets, tabulacoes],
  )

  const handleDropdownClick = () => {
    setSearchTerm('')
    setIsDropdownOpen((prev) => !prev)
  }

  const handleInputClick = (e) => {
    e.stopPropagation() // Impede que o clique no Input feche o Dropdown
    setIsDropdownOpen(true)
  }

  const handleBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDropdownOpen(false) // Fecha o Dropdown apenas se clicar fora
    }
  }

  return (
    <Container>
      <strong>
        {convertToFullPathList(tabulacoes, '').find(
          (item) => item.id === id_tabulacao,
        )?.nome ?? 'Selecione uma tabulação'}
      </strong>
      <Dropdown
        text={
          findItemNameById(id_tabulacao, tabulacoes) ??
          'Selecione uma tabulação'
        }
        open={isDropdownOpen}
        onClick={handleDropdownClick}
        onBlur={handleBlur}
        icon="filter"
        floating
        labeled
        button
        className="icon"
      >
        <DropdownMenu>
          <Input
            icon="search"
            iconPosition="left"
            className="search"
            onClick={handleInputClick}
            value={searchTerm}
            onChange={(e) => {
              console.log('searchTerm', e.target.value)
              setSearchTerm(e.target.value)
            }}
            placeholder="Procurar..."
            type="text"
          />
          <DropdownDivider />
          <DropdownHeader icon="tags" content="Tabulações" />
          <DropdownMenu scrolling>
            {convertToFullPathList(tabulacoes, '')
              .filter((item) =>
                item.nome.toLowerCase().includes(searchTerm.toLowerCase()),
              )
              .map((option) => (
                <DropdownItem
                  key={option.id}
                  value={option.id}
                  text={option.nome}
                  active={option.id === id_tabulacao}
                  style={{
                    backgroundColor:
                      option.id === id_tabulacao ? '#d2d2d2' : '#fff',
                  }}
                  onClick={() => {
                    setTabulacaoLocal(option.id)
                  }}
                />
              ))}
          </DropdownMenu>
        </DropdownMenu>
      </Dropdown>
    </Container>
  )
}
